var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDustIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 29.246,
    viewBox: "0 0 22 29.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2098",
    "data-name": "Rectangle 2098",
    width: 22,
    height: 29.246,
    transform: "translate(0 0)",
    fill: "#fdf8f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dust-icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1926",
    "data-name": "Group 1926",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M11.955,27.2v2.049H6.691V27.329H0V2.231H6.653V0h5.283c0,.662.02,1.311,0,1.937-.02.352.117.43.43.489A10.477,10.477,0,0,1,20,7.024a12.436,12.436,0,0,1,1.876,5.713,16.817,16.817,0,0,1-.883,7.807A10.2,10.2,0,0,1,13.027,27c-.349.079-.681.137-1.073.2M5.243,23.088c1.78,0,3.522.137,5.223-.02a5.994,5.994,0,0,0,5.674-4.813,13.51,13.51,0,0,0,.059-6.671,6.048,6.048,0,0,0-5.947-5.107c-1.643-.117-3.287-.039-4.931-.059-.02,0-.039.02-.1.059.021,5.517.021,11.071.021,16.611",
    transform: "translate(0 0)",
    fill: "#fdf8f8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustIcon);
export default __webpack_public_path__ + "static/media/dust-icon.c834c2b943f84252728676a5b07628a5.svg";
export { ForwardRef as ReactComponent };